import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BookingValidation } from 'uplisting-frontend/validations';
import { formatLocalDate } from 'uplisting-frontend/utils/date';

interface IBookingAttributes {
  checkIn: Date;
  checkOut: Date;
  property: ModelRegistry['property'];
  multiUnit?: ModelRegistry['multi-unit'];
}

export default class BookingRepositoryService extends BaseRepositoryService<
  ModelRegistry['booking']
> {
  recordName = 'booking';
  implementMethods = ['buildChangeset', 'findRecord', 'peekRecord', 'save'];

  validation = BookingValidation;

  public createBooking(
    attributes: IBookingAttributes,
  ): ModelRegistry['booking'] {
    const discount = this.store.createRecord('extra-price', {
      type: 'discount',
    });

    const charge = this.store.createRecord('extra-price', { type: 'charge' });

    const price = this.store.createRecord('price', {
      numberOfGuests: 1,
      cleaningFee: attributes.property.propertyFee?.cleaningFee,
      reservationTax: attributes.property.propertyFee?.perBookingAmountTax,
      discounts: [discount],
      charges: [charge],
    });

    if (!attributes.multiUnit) {
      delete attributes.multiUnit;
    }

    return this.store.createRecord('booking', {
      ...attributes,
      checkIn: formatLocalDate(attributes.checkIn),
      checkOut: formatLocalDate(attributes.checkOut),
      price,
      automatedMessagesEnabled: true,
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/booking': BookingRepositoryService;
  }
}
